import request from '@/utils/request'

const api = {
  getTree: "/articleCate/getTree",
  delete: "/articleCate/deleteInfo",
  save: "/articleCate/save",
  detail: "/articleCate/detail"
}

export default api

export function getTree(data){
  return request({
    url: api.getTree,
    method: 'post',
    data
  })
}

export function save(data){
  return request({
    url: api.save,
    method: 'post',
    data
  })
}

export function del(data){
    return request({
      url: api.delete,
      method: 'post',
      data
    })
}

export function detail(data){
    return request({
      url: api.detail,
      method: 'post',
      data
    })
}

